<template>
<div>
  <h1>{{ t('MEU_CARTAO_GIRO') }}</h1>
  <div v-if="temCartaoHabilitado && activeGiroCard" class="innerForm">
    <v-text-field  :value="activeGiroCard.cardNumber" style="pointer-events:none;"></v-text-field>
    <a appEventcategory="meus-dados" appEvent="true"  appEventLabel="bloquear cartão giro"  class="popupLink" @click="() => openPopup()">{{ t('BLOQUEAR_CARTAO_GIRO') }}</a>
  </div>
    <div v-else-if="temCartaoCadastrado" class="innerForm">
        <a @click="openPopup" appEvent="true"  appEventCategory="meus-dados" appEventLabel="adicionar novo cartão giro">{{ t('ADICIONAR_CARTAO_GIRO') }}</a>
        
  </div>
  <div v-else class="innerContainer meuCartaoGiro">
     <v-form
          ref="form"
          v-model="valid"
        >
    <v-text-field 
              v-mask="['######################']"
              color="#E46C0A "
              :placeholder="t('FORM.NR_GIRO')"
              :type="show1 ? 'text' : 'password'"
              v-model="giroNumber"
               
              required>
               <template v-slot:append>
                <img v-if="!show1" width="24" src="../assets/img/olhovazado.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              <v-text-field 
              v-mask="['######################']"
              color="#E46C0A "
              :rules="[() => (this.giroNumber === this.giroConfirmNumber) || t('VALIDATIONS.GIRO_INVALIDO')]"
              v-model="giroConfirmNumber"
              :placeholder="t('FORM.CONFIRM_NR_GIRO')"  
              :type="show2 ? 'text' : 'password'"
                     
              required>
               <template v-slot:append>
                <img v-if="!show2" width="24" src="../assets/img/olhovazado.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
               </v-form>
  </div>
    <v-app>
      <div style='z-index: 9999; position: fixed; background: black; color: white;padding:10px; right: 10px; top: 10px;display: none;'>
        CARD STATE: {{ cardState }}<br>
        Saldo Bloqueado: {{ saldoBloqueado}}
      </div>
   <v-dialog @input="v => v || closePopup()" v-model="dialog" max-width="600px">
      <!-- Modal adicionar cartão -->
      <v-card v-show="cardState == ENUMS.CARD_STATUS.CARD_ADD">
        <v-card-title class="styled-header">
          <span class="headline">{{ t('ADICIONAR_CARTAO_GIRO') }}</span>
          <span @click="closePopup" class="close">X</span>
        </v-card-title>
       
      <v-card-text>
         <v-form
          ref="form"
          v-model="valid"
        >
           <v-text-field 
           v-mask="['######################']"
              color="#E46C0A "
              :placeholder="t('FORM.NR_GIRO')"
              :rules="[() => !!this.giroNumber || t('VALIDATIONS.REQUIRED_FIELD')]" 
            
              :type="show1 ? 'text' : 'password'"
              v-model="giroNumber"
                     
              required>
               <template v-slot:append>
                <img v-if="!show1" width="24" src="../assets/img/olhovazado.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              <v-text-field 
              v-mask="['######################']"
              color="#E46C0A "
              :rules="[() => !!this.giroConfirmNumber || t('VALIDATIONS.REQUIRED_FIELD'),() => (this.giroNumber === this.giroConfirmNumber) || t('VALIDATIONS.GIRO_INVALIDO')]"
              v-model="giroConfirmNumber"
              :placeholder="t('FORM.CONFIRM_NR_GIRO')"   
              :type="show2 ? 'text' : 'password'"
                     
              required>
               <template v-slot:append>
               <img v-if="!show2" width="24" src="../assets/img/olhovazado.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              <p v-if="requireImagesDocuments">
                {{ t('PARA_EFETIVAR_TRANSFERENCIA') }}
              </p>
              <div class="fileDiv" v-if="requireImagesDocuments">
                <div v-if="cardGiro">
                  <span @click="removeFile('cardGiro')" >x</span>                  
                  <span >{{cardGiro}}</span>
                </div>
                <div v-show="!cardGiro">
                  <img @click="uploadFile" appEvent="true"  appEventCategory="adicionar-giro" appEventLabel="tire uma foto do verso do giro" src="../assets/img/Camera.svg"/>
                  <label for="cardGiro" @click="uploadFile">{{ t('SELECIONE_FOTO_GIRO') }}</label>
                  <input @change="checkFile" name="cardGiro" type="file" accept="image/*" style="display:none;" required>
                </div>
               
              </div>
              <div class="fileDiv" v-if="requireImagesDocuments">
                <div v-if="docGiro" class="nameFile">
                  <span @click="removeFile('docGiro')">x</span>
                  <span>{{docGiro}}</span>
                </div>
                <div v-show="!docGiro" class="inputFile">
                  <img @click="uploadFile"  appEvent="true" appEventCategory="adicionar-giro" appEventLabel="tire uma foto do seu documento" src="../assets/img/Camera.svg"/>
                  <label for="docGiro" @click="uploadFile">{{ t('SELECIONE_FOTO_DOCUMENTO') }}</label>
                  <input @change="checkFile" name="docGiro" type="file" accept="image/*" style="display:none;" required>               
                </div>
              </div>
              
            </v-form>
            <span style="color:#ff0000;font-family:Roboto;float:right;" v-if="errorMessage"> {{errorMessage}} </span>
            <v-card-title >
            </v-card-title>
            <!-- <v-btn color="orange" @click="create"></v-btn>  -->
              <a @click="create"  appEvent="true" appEventCategory="adicionar-giro" appEventLabel="confirmar" class="btn block">{{ t('CONFIRMAR') }}</a>
        </v-card-text>
      </v-card>

      <!-- Apenas Mensagem -->
      <v-card  class="withoutHeader" v-if="cardState == ENUMS.CARD_STATUS.MESSAGE">
         <v-card-title>
        </v-card-title>
        <v-card-text>
          <p>{{dialogMessage}}</p>
          <!-- <v-btn color="orange" @click="closePopup">confirmar</v-btn>  -->
            <a @click="closePopup" class="btn block">{{ t('FECHAR') }}</a>
        </v-card-text>
      </v-card>

      <!-- Modal de confirmação de remoção -->
      <v-card class="withoutHeader" v-else-if="cardState == ENUMS.CARD_STATUS.CARD_REMOVE">
        <v-card-title>
        </v-card-title>
        <v-card-text>
           <span class="headline">{{ t('DESEJA_BLOQUEAR_GIRO')}}</span>
            <p>{{ t('DESEJA_BLOQUEAR_GIRO_TEXTO_1')}}</p>
            <p>{{ t('DESEJA_BLOQUEAR_GIRO_TEXTO_2')}}</p>
        </v-card-text>
         <a v-if="!loading"  @click="blockCard(activeGiroCard)"  appEvent="true" appEventcategory="pop-up" appEventLabel="bloquear cartão giro"  class="btn block">{{ t('BLOQUEAR')}}</a>
         <p v-if="loading" style="text-align:center; padding: 10px; font-weight: bold">{{ t('AGUARDE')}}</p>
        <v-card-title></v-card-title>
      </v-card>
      
      <!-- Modal de cartão removido -->
      <v-card  class="withoutHeader" v-if="cardState == ENUMS.CARD_STATUS.CARD_REMOVED || cardState == ENUMS.CARD_STATUS.CARD_REMOVED_WITH_CREDIT">
        <v-card-title></v-card-title>
        <v-card-text>
          <p>{{ t('DESEJA_BLOQUEAR_GIRO')}}</p>
          <p><strong>{{ t('GIRO_BLOQUEADO_TEXTO_1', [formatMoney(saldoBloqueado)])}}</strong></p>
          <p v-if="cardState == ENUMS.CARD_STATUS.CARD_REMOVED_WITH_CREDIT">{{ t('GIRO_BLOQUEADO_TEXTO_2')}}</p>
        </v-card-text>
        <a @click="openPopup" class="btn block">{{ t('ADICIONAR_CARTAO')}}</a>
        <v-card-title></v-card-title>
      </v-card>
    </v-dialog>
  </v-app>
  
</div>
</template>

<script>
import {VTextField,VDialog,VCard,VCardTitle,VCardText,VApp,VForm} from 'vuetify/lib'
import {formatMoney,resolvePromise} from '../helpers/helpers'
import {save, blockWithCredit, pegaUltimoCartaoGiro/*,block*/} from '../services/girocard.service'
import {blockCard as blockCardSbe, checkCard,cardPending} from '../services/sbe.service'
import { translate } from '../services/translate.service';
//import { blockGiroCard as block, blockCard as blockCardSbe, /*checkCard as checkCard, cardPending as cardPending,*/ pegaUltimoCartaoGiro } from '../services/mock.service';
const enum_CardState = {
  MESSAGE: 'MESSAGE',
  CARD_ADD: 'CARD_ADD',
  CARD_REMOVE: 'CARD_REMOVE',
  CARD_REMOVED: 'CARD_REMOVED',
  CARD_REMOVED_WITH_CREDIT: 'CARD_REMOVED_WITH_CREDIT'
}
export default {
  name: 'MeuCartaoGiro',
  data(){
     return{
      loading:false,
      ENUMS: { CARD_STATUS: enum_CardState },
      valid:false,
      show1:false,
      show2:false,
      dialog:false,
      dialogMessage:null,
      addCard:false,
      giroNumber:null,
      giroConfirmNumber:null,
      cardGiro:null,
      docGiro:null,
      tempGiro:null,
      saldoBloqueado: 0,
      cardState: null, // enum_CardState
      errorMessage:null
    }
  },
  props: {
      activeGiroCard:{
        type:Object
      },
      giroCards:{
        type:Array
      },
      userId:{
        type:Number
      }
  },
  methods:{
    t:translate,
    formatMoney: number => formatMoney(number*100),
    checkFile({target}){
      this.errorMessage = null
      const
        hasFile = target.files.length > 0,
        file = hasFile && target.files[0] 
      if(hasFile) this[target.name] = file.name
      if((file.size/Math.pow(1024,2)).toFixed(2) > 3){
        this[target.name] = "Atenção, Arquivo muito Grande,escolha outro"
      } 

    },
    removeFile(el){
      if(!el){
        this.cardGiro = null
        this.docGiro = null
        try{
          document.querySelector("input[name='cardGiro']").value = '' 
          document.querySelector("input[name='docGiro']").value = ''
        }
        catch(err){
          console.log(err)
        }
      }
      else{
        try{
          this[el] = null
          document.querySelector('input[name='+el+']').value = ''
        }
        catch(err){
          console.log(err)
        }
      }
       
    },
    uploadFile({target}){
      const input = target.nextSibling
      input.click()
    },
    openPopup(addCard){
      
       if(this.$refs.form) this.$refs.form.reset()
      this.dialogMessage = null
      this.addCard = !!addCard
      this.cardState = this.addCard ? enum_CardState.CARD_ADD : enum_CardState.CARD_REMOVE;
      if(this.cardState == enum_CardState.CARD_ADD) {
        pegaUltimoCartaoGiro().then(card => {
          this.saldoBloqueado = (card && card.saldoBloqueio > 0) ?  card.saldoBloqueio : 0;
          this.dialog = true;
        });
      } else {
        this.dialog = true
      }
    },
    closePopup(){
      if(this.$refs.form) this.$refs.form.reset()
      this.removeFile()
      this.errorMessage = null
      this.cardState = null;
      this.dialog = false
    },
    removeGiroCard(message){
      this.dialogMessage = message
      this.cardState = enum_CardState.MESSAGE;
      this.activeGiroCard = null 
    },
    sucessGiroCard(message,cardNumber,totalCredit){
      debugger;
      this.dialogMessage = message
      if(cardNumber) {
        this.cardState = enum_CardState.MESSAGE;
      }
      this.tempGiro = {
        active:true,
        cardNumber: cardNumber,
        creditBalance:0,
        id:'',
        promoBalance:0
      }
      this.saldoBloqueado = totalCredit ? totalCredit : 0;
    },
    create(){
      const 
        hasDocGiro = this.requireImagesDocuments ? (this.docGiro && this.docGiro !== "Atenção, arquivo muito grande,escolha outro") : true,
        hasCardGiro = this.requireImagesDocuments ? (this.cardGiro && this.cardGiro !== "Atenção, arquivo muito grande,escolha outro"): true
      if(!hasCardGiro || !hasDocGiro) this.errorMessage = "As imagens são obrigatórias" 
      if(!this.$refs.form.validate() || !hasDocGiro || !hasCardGiro) return

      const card = new FormData()
      card.append("CardNumber",this.giroNumber)
      card.append("Active", true)
      let messageAddCard = "Seu Giro foi adicionado com sucesso."
      if(this.requireImagesDocuments) {
        card.append("CardPicture",document.querySelector("input[name='cardGiro']").files[0], this.cardGiro)
        card.append("DocumentPicture",document.querySelector("input[name='docGiro']").files[0], this.docGiro)
        card.append("sendEmailCardTransfer", true)
        messageAddCard = translate('GCARD_TRANSFERENCIA');
      }
      
      resolvePromise(save(card),() => this.sucessGiroCard(messageAddCard, this.giroNumber),(err)=>{
        this.dialogMessage = err;
        this.cardState = enum_CardState.MESSAGE;
      },this)
      if(document.querySelector("input[name='cardGiro']"))
        document.querySelector("input[name='cardGiro']").value = ""
      if(document.querySelector("input[name='docGiro']"))
      document.querySelector("input[name='docGiro']").value = ""
      
    } ,
    blockCard({cardNumber,id}){
      this.loading = true;
      const setMessageError = (message) => {
        this.dialogMessage = message
        this.cardState = enum_CardState.MESSAGE;
      };
      try {
        checkCard(cardNumber).then(({data}) => {
          let totalCredit = 0;
          totalCredit = totalCredit + parseFloat(data.balance || '0.00');
          cardPending(cardNumber).then(({data}) => {
            totalCredit = totalCredit + parseFloat(data.PENDING.replace(',','.'));
            blockCardSbe(cardNumber).then(({status}) => {
              if(status == 204) {
                blockWithCredit(id, totalCredit).then(() => {
                  this.cardState = totalCredit > 0 ? enum_CardState.CARD_REMOVED_WITH_CREDIT : enum_CardState.CARD_REMOVED;
                  this.sucessGiroCard(translate('GCARD_BLOQUEADO'), null, totalCredit);
                  this.loading = false;
                }).catch(() => {
                  setMessageError(translate('ERRO_BLOQUEAR_GCARD', ['| err: 1']));
                  this.loading = false;
                })
              } else {
                setMessageError(translate('ERRO_CONTATO_GCARD', ['| err: 1']));
                this.loading = false;
              }
            }).catch(() => {
              setMessageError(translate('ERRO_BLOQUEAR_GCARD', ['| err: 2']));
              this.loading = false;
            })
          }).catch(() => {
            setMessageError(translate('ERRO_VALIDAR_GCARD', ['| err: 1']));
            this.loading = false;
          })
        }).catch(() => {
          setMessageError(translate('ERRO_VALIDAR_GCARD', ['| err: 2']));
          this.loading = false;
        });
      } catch(err) {
        setMessageError(err);
        this.loading = false;
      }
    }
  },
  computed:{
    temCartaoCadastrado(){
      return this.giroCards ? this.giroCards.length > 0 : false
    },
    temCartaoHabilitado(){
      return !!this.activeGiroCard || !!this.tempGiro
    },
    requireImagesDocuments() {
      return this.saldoBloqueado && this.saldoBloqueado > 0;
    },
    temCartaoTemporario(){
      return !!this.tempGiro 
    }
  },
  components:{
    VTextField,
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VApp,
    VForm,
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/meuCartaoGiro.scss";
 .v-dialog .btn{ width: 50%; }
</style>
